export default {
  setUsgDevice({ commit }, payload) {
    commit('setUsg', payload)
  },
  setPatientJustify({ commit }, payload) {
    commit('setPatientJustify', payload)
  }
}
